/**
 * Helper for assets served from the bigdata-website-uploads S3 bucket
 * instead of being bundled with the app. Keeps images swappable without
 * a rebuild and keeps the JS bundle smaller.
 */
const S3_BASE_URL = 'https://bigdataghana.com/s3'

/** Encodes each path segment (so filenames with spaces/&/etc. work) while keeping "/" as a separator. */
export function s3Asset(path: string): string {
  return `${S3_BASE_URL}/${path.split('/').map(encodeURIComponent).join('/')}`
}

/** Shortcut for files under "Aws Partner logo/". */
export function awsPartnerLogo(filename: string): string {
  return s3Asset(`Aws Partner logo/${filename}`)
}

/** Shortcut for files under "Teams/". */
export function teamAsset(filename: string): string {
  return s3Asset(`Teams/${filename}`)
}

/** Shortcut for files under "Service Page/". */
export function servicePageAsset(path: string): string {
  return s3Asset(`Service Page/${path}`)
}

/** Shortcut for files under "Service Page/Client Logos/". */
export function clientLogo(filename: string): string {
  return s3Asset(`Service Page/Client Logos/${filename}`)
}

/** Shortcut for files under "Data Store/". */
export function dataStoreAsset(path: string): string {
  return s3Asset(`Data Store/${path}`)
}

/** Shortcut for files under "Cloud Platform/". */
export function cloudPlatformAsset(filename: string): string {
  return s3Asset(`Cloud Platform/${filename}`)
}

/** Shortcut for files under "Cloud Platform/Our Solutions/". */
export function ourSolutionsAsset(path: string): string {
  return s3Asset(`Cloud Platform/Our Solutions/${path}`)
}

/** Shortcut for files under "Cloud Platform/What we do/". */
export function whatWeDoAsset(filename: string): string {
  return s3Asset(`Cloud Platform/What we do/${filename}`)
}

/** Shortcut for files under "Our Projects/". */
export function ourProjectsAsset(path: string): string {
  return s3Asset(`Our Projects/${path}`)
}

/** Shortcut for hero section background images stored in S3 under "Hero/". */
export function heroAsset(filename: string): string {
  return s3Asset(`Hero/${filename}`)
}
